module.exports = __webpack_public_path__ + "media/images/shark/Naranjo_9252-1-p-500-7807b97e1603bf078e248a76a20238a5.jpeg";